import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

const LANGS = ['EN', 'KO', 'JA', 'ZH']

export default function LanguageSwitcher() {
    const { i18n } = useTranslation()
    const current = (i18n.language || 'en').slice(0, 2).toLowerCase()

    /* keep <html lang="..."> in sync so :lang(ko) selectors apply correctly */
    useEffect(() => {
        document.documentElement.lang = current
    }, [current])

    return (
        <div className="lang-switcher" role="group" aria-label="Language">
            {LANGS.map((lang) => {
                const code = lang.toLowerCase()
                const active = current === code
                return (
                    <button
                        key={lang}
                        type="button"
                        className={`lang-btn${active ? ' active' : ''}`}
                        onClick={() => i18n.changeLanguage(code)}
                        aria-pressed={active}
                    >
                        {lang}
                    </button>
                )
            })}
        </div>
    )
}
